import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageBG = styled.img`
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: -1;
`;

export const Wrapper = styled.div`
  display: flex;
  max-width: 1022px;
  width: 100%;
  justify-content: space-between;
`;

export const BoxlogIn = styled.div`
  /* display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center; */
  width: 448px;
  min-height: 500px;
  border-radius: 24.5px;
  background: linear-gradient(
    126.6deg,
    rgba(255, 255, 255, 0.5) 28.69%,
    rgba(255, 255, 255, 0) 100%
  );
  padding: 20px 24px;
`;

export const LeftImage = styled.div`
  display: flex;
  align-items: center;
`;
